import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useSubscription } from '../../contexts/SubscriptionContext';

function UpgradeBanner() {
  const { t } = useTranslation('subscription');
  const { isPro } = useAuth();
  const { openUpgradeModal } = useSubscription();

  if (isPro) return null;

  return (
    <div className="upgrade-banner">
      <p>{t('banner.message')}</p>
      <button type="button" className="primary-btn standout-btn" onClick={() => openUpgradeModal('default')}>
        {t('banner.cta')}
      </button>
    </div>
  );
}

export default UpgradeBanner;
